import styled from 'styled-components'

export const Video = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.7);
  z-index: 9999999;
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  .video {
    width: 90%;
    max-width: 800px;
    border: 8px solid black;
    position: relative;
    background: black;

    > button {
      background: transparent;
      border: 0;
      outline: none;
      position: absolute;
      right: -8px;
      top: -60px;
      cursor: pointer;
      width: 70px;
      height: 50px;
    }
  }

  .embed-container { 
    position: relative; 
    padding-bottom: 56.25%; 
    height: 0; 
    overflow: hidden; 
    max-width: 100%; 
  } 
  
  .embed-container iframe, 
  .embed-container object, 
  .embed-container embed { 
    position: absolute; 
    top: 0; 
    left: 0; 
    width: 100%; 
    height: 100%; 
  }

  &.open {
    display: flex;
  }
`

export const Main = styled.div`
  overflow: hidden;
  max-width: 100%;
  position: relative;
  padding: 60px 0 0px 0;
  background: #f2f6f7;

  .grid {
    display: flex;
  }

  .main-content {
    display: flex;
    flex: 12;
    justify-content: center;
    flex-direction: column;
    padding-right: 100px;
    padding-bottom: 50px;
  }

  .primary {
    font-size: 55px;
    font-weight: 900;
    line-height: 1;
    color: #000;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;

    span {
      font-size: 55px;

      > div {
        font-size: 55px;
        font-weight: 900;
        color: var(--color-primary);
      }
    }
  }

  .secondary {
    font-size: 32px;
    color: #606060;
    margin-bottom: 50px;
  }

  .feature-image {
    flex: 8;
    /* width: 1120px;
    height: 604px; */
    /* position: absolute; */
  }

  .ctas {
    display: flex;
    flex-wrap: wrap;

    a {
      text-decoration: none
    }
    
    button {
      margin-right: 25px;
      margin-bottom: 10px;
    }

    .button-play {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      cursor: pointer;
      background: transparent;
      border: 0;

      img {
        border-radius: 30px;
      }

      div.label {
        width: 100px;
        margin-left: 13px;
      }
    }
  }

  @media screen and (max-width: 1000px) {
    padding-top: 30px;
    padding-bottom: 0;

    .grid {
      flex-direction: column;

      > div {
        min-height: auto;
      }
    }

    .main-content {
      padding-bottom: 0;
      padding-right: 0;
    }

    .primary {
      font-size: 32px;
      margin-bottom: 20px;

      span {
      font-size: 32px;

      > div {
        font-size: 32px;
        font-weight: 900;
        color: var(--color-primary);
      }
    }
    }

    .secondary {
      font-size: 24px;
      margin-bottom: 30px;
    }

    .feature-image {
      display: none;
    }

    .ctas {
      margin-bottom: 20px;
    }
  }
`

export const Customers = styled.div`
  background: #f2f6f7;
  padding-bottom: 80px;

  .grid {
    display: flex;
    justify-content: center;
  }

  .wrapper {
    flex: 1;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);

    &:hover {
      .show-customers {
        opacity: 1;
        transform: translateY(5%);
      }

      .table-customers{
        &__item {
          transform: scale(1.2) translateY(-20%);
        }

        &__overlay {
          opacity: 1;
        }
      }
    }
  }

  .show-customers {
    opacity: 0;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(80%);
    transition: all .7s;
  }

  .table-customers {
    display: flex;
    justify-content: center;
    padding: 40px 0;
    position: relative;

    &__item {
      height: 75px;
      display: flex;
      align-items: center;
      padding: 0 30px;
      transition: all 1.7s;
    }

    &__overlay {
      backdrop-filter: blur(5px);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: all 0.3s;
    }
  }

  @media screen and (max-width: 1000px) { 
    .table-customers {
      flex-wrap: wrap;

      &__item {
        height: 100px;
      }

      &__overlay {
        display: none
      } 
    }

    .wrapper {
      &:hover {
        .show-customers {
          opacity: 1;
          transform: translateY(0);
        }

        .table-customers{
          &__item {
            transform: scale(1) translateY(0);
          }
        }
      }
    }

    .show-customers {
      opacity: 1;
      transform: translateY(0);
      position: relative;
      left: auto;
      top: auto;
      width: auto;
      height: auto;
      margin-bottom: 30px;
    }
  }
`